import { useMutation } from "@apollo/client";
import { gql } from "__generated__/gql";
import { Charter, Contract } from "types/index";
import { CharterSubtype } from "__generated__/enums";

type linkContractType = Pick<Contract, "id" | "charterSubtype"> & { charters?: Array<Pick<Charter, "id"> | null> | null }

const useLinkContract = ({ onLink }: { onLink: () => void; }) => {

	const [ link, { loading: linkLoading } ] = useMutation(LINK_CONTRACT_MUTATION);
	const [ linkSupplierCharter, { loading: linkSupplierCharterLoading } ] = useMutation(LINK_SUPPLIER_CHARTER_MUTATION);

	return {
		linkContract: (contract: linkContractType, charter: { id: number }) => {

			if (contract.charterSubtype === CharterSubtype.Supplier) {

				linkSupplierCharter({
					variables: {
						supplierCharterId: contract.charters?.[0]?.id as number,
						suppliedCharterId: charter.id,
					},
				}).then(() => {
					onLink();
				});

			} else {
				link({
					variables: {
						contractId: contract.id,
						charterId: charter.id,
					},
				}).then(() => {
					onLink();
				});
			}
		},
		loading: linkLoading || linkSupplierCharterLoading,
	};
};

const LINK_CONTRACT_MUTATION = gql(`#graphql
	mutation linkContract_contractBlockNew($contractId: Long!, $charterId: Long!) {
		linkContract(charterId: $charterId, contractId: $contractId) {
			id
		}
	}
`);

const LINK_SUPPLIER_CHARTER_MUTATION = gql(`#graphql
	mutation linkSupplierCharter_contractBlockNew($supplierCharterId: Long!, $suppliedCharterId: Long!) {
		linkSupplierCharter(supplierCharterId: $supplierCharterId, suppliedCharterId: $suppliedCharterId)
	}
`);

export default useLinkContract;
